import React from "react";
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";

import Home from "./pages/home/home";
import Gateway from "./pages/home/gateway_test";
import Payment from "./pages/home/payment";

// import TokenPrice from "./pages/home/tokenprice";
//import BuyToken from "./pages/buy/buyToken";
// import TokenPrice from "./pages/token_price/tokenPrice";
import './App.css';
//import './i18n';

class App extends React.Component {

  

  render() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route exact path="/:referral?" element={<Home />}></Route>
          <Route exact path="/gateway" element={<Gateway />}></Route>
          <Route exact path="/payment/:status?" element={<Payment />}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
  }
}

export default App;
